import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "common",
  initialState: {
    demoTourFinished: true,
    accountCounts: 0,
    backupTrialInfo: {
      trialMessage: "",
      xeroId: "",
      trialBackupRemaining: 0,
    },
    addCardModalOpen: false,
    allNotifications: [],
    isAccountDataFilled: false,
    profilePicUrl: "/assets/image/default-avatar.png",
    userData: {
      email: "",
      name: "",
      picture: "",
    },
    emailVerified: null, // null = unknown, true = verified, false = not verified
    profileCompleted: null, // null = unknown — set from auth0-check
    isBlocked: false,
    authMethod: {
      isSocialLogin: false,
      provider: null,
      providerName: "Email",
    },
  },

  reducers: {
    setDemoTourFinished(state, action) {
      state.demoTourFinished = action.payload;
    },
    setAccountCounts(state, action) {
      state.accountCounts = action.payload;
    },
    setBackupTrialInfo(state, action) {
      state.backupTrialInfo = action.payload;
    },
    setAddCardModalOpen(state, action) {
      state.addCardModalOpen = action.payload;
    },

    setAllNotifications(state, action) {
      state.allNotifications = action.payload;
    },
    setIsAccountDataFilled(state, action) {
      state.isAccountDataFilled = action.payload;
    },
    setProfilePicUrl(state, action) {
      state.profilePicUrl = action.payload;
    },
    setUserData(state, action) {
      state.userData = action.payload;
    },
    setEmailVerified(state, action) {
      state.emailVerified = action.payload;
    },
    setProfileCompleted(state, action) {
      state.profileCompleted = action.payload;
    },
    setIsBlocked(state, action) {
      state.isBlocked = action.payload;
    },
    setAuthMethod(state, action) {
      state.authMethod = action.payload;
    },
  },
});

export const {
  setDemoTourFinished,
  setAccountCounts,
  setBackupTrialInfo,
  setAddCardModalOpen,
  setAllNotifications,
  setIsAccountDataFilled,
  setProfilePicUrl,
  setUserData,
  setEmailVerified,
  setProfileCompleted,
  setIsBlocked,
  setAuthMethod,
} = commonSlice.actions;

export default commonSlice.reducer;
